import React from "react";
import { View, StyleSheet, Text } from "react-native";
import ChatInput from "./ChatInput";
import { WorkspaceHeader } from "../../components/chatNewInterface/interfaceComponents/workspaceHeader/WorkspaceHeader";
import { AttachmentInput } from "../../graphql/generated/graphql";

interface ChatEmptyStateProps {
  inputValue: string;
  onChangeText: (text: string) => void;
  onSubmit: () => void;
  isStreaming: boolean;
  title: string;
  attachment: AttachmentInput | null;
  onAttachmentChange: (attachment: AttachmentInput | null) => void;
  activeWorkspaceType: "general" | "course" | "support";
}

const ChatEmptyState = ({
  inputValue,
  onChangeText,
  onSubmit,
  isStreaming,
  title,
  attachment,
  onAttachmentChange,
  activeWorkspaceType,
}: ChatEmptyStateProps) => {
  return (
    <View style={styles.container}>
      <WorkspaceHeader title={title} />
      <View style={styles.content}>
        <View style={styles.emptyStateArea}>
          <View style={styles.emptyStateContent}>
            <Text style={styles.emptyStateTitle}>How can I help you today?</Text>
            <ChatInput
              value={inputValue}
              onChangeText={onChangeText}
              onSubmit={onSubmit}
              disabled={isStreaming}
              placeholder="Type a message..."
              showSuggestions={false}
              attachment={attachment}
              onAttachmentChange={onAttachmentChange}
              activeWorkspaceType={activeWorkspaceType}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  emptyStateArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafbb3",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  emptyStateContent: {
    width: "100%",
    maxWidth: 770,
    paddingHorizontal: 20,
    paddingTop: 60,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
  },
  emptyStateTitle: {
    fontSize: 32,
    fontWeight: "600",
    color: "#1f2937",
    textAlign: "center",
  },
});

export default ChatEmptyState;
